import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  setMetadataTypesList,
  setChosenMetadataElement,
  clearChosenMetadataElement,
} from '../../../reducers/documentation/metadataReducer';
import { useDocumentationApiFacade } from '../../../apis/facades/useDocumentationApiFacade';
import { telemetry } from '../../../telemetry';
import { mapMissingInternalIdToMetadataId } from '../helpers';

export const useMetadata = () => {
  const dispatch = useDispatch();
  const { get_metadataData } = useDocumentationApiFacade();

  const fetchMetadata = useCallback(
    async (metadataName: string, crmOrgId: string) => {
      try {
        const metadataTypesList = await get_metadataData(metadataName);
        const updatedListWithType = metadataTypesList.map((item) => ({
          ...mapMissingInternalIdToMetadataId(item),
          type: metadataName,
        }));
        dispatch(
          setMetadataTypesList({
            metadataTypesList: updatedListWithType,
            type: metadataName,
            crmOrgId,
          }),
        );
      } catch (e) {
        telemetry.captureError(e);
        dispatch(setMetadataTypesList({ metadataTypesList: [], type: metadataName, crmOrgId }));
      }
    },
    [dispatch, get_metadataData],
  );

  const setMetadataElement = useCallback(
    (chosenMetadataElementId: string, type: string, crmOrgId: string) => {
      dispatch(setChosenMetadataElement({ id: chosenMetadataElementId, type, crmOrgId }));
    },
    [dispatch],
  );

  const clearMetadataElement = useCallback(() => {
    dispatch(clearChosenMetadataElement());
  }, [dispatch]);

  return { fetchMetadata, setMetadataElement, clearMetadataElement };
};
